// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const RectangleOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_4799)"},"children":[{"tag":"path","attrs":{"d":"M19 5H5a2 2 0 00-2 2v10c0 1.1.9 2 2 2h14a2 2 0 002-2V7a2 2 0 00-2-2zm0 12H5V7h14v10z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_4799"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"rectangle","theme":"outlined"};

const RectangleOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={RectangleOutlinedSvg} />;
  RectangleOutlined.displayName = 'RectangleOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(RectangleOutlined);
